import { AppInfoReport } from '@yandex-360/telemost-sdk/models/stats';

import { getStore } from '../../../../init-store';
import { GRID_VIEW } from '../constants';

export const getAppInfoReport = (): AppInfoReport => {
    const {
        ua,
        call: {
            record: { isRecording },
            screenSharing: { desktopSharingStatus },
            videoGrid: { activeGridView },
        },
    } = getStore().getState();
    let platform: AppInfoReport['platform'];
    switch (ua.OSFamily) {
        case 'MacOS':
            platform = 'mac';
            break;
        case 'Windows':
            platform = 'win';
            break;
        case 'Linux':
            platform = 'lin';
            break;
        default:
            platform = ua.OSFamily;
    }
    return {
        platform,
        recording: !!isRecording,
        screencast: desktopSharingStatus === 'local',
        speakerLayout: activeGridView === GRID_VIEW.PRESENTER,
        vbg: false,
    };
};
